// import { min, max } from 'd3-array';
import { timeFormat, timeParse } from 'd3-time-format';
import { extent } from 'd3-array';
import { bandAxis, linearAxis, timeAxis } from '../../../factory/axes';
import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 30,
    right: isMobile ? 10 : 30,
    bottom: 20,
    left: 35,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  // const padding = 0.15;
  const padding = 0;

  const parser = timeParse('%Y-%m-%d'); // https://github.com/d3/d3-time-format;
  const keys = Object.keys(data[0]).slice(1);

  const dataDate = keys.map(id => ({ id, values: data.map(d => ({ date: parser(d.label), value: +d[id] })) }));

  const rParser = timeParse('%m/%d/%Y'); // https://github.com/d3/d3-time-format;
  const recessionData = [
    // { start: '8/1/1929', end: '3/1/1933' },
    // { start: '5/1/1937', end: '6/1/1938' },
    // { start: '2/1/1945', end: '10/1/1945' },
    // { start: '11/1/1948', end: '11/1/1949' },
    // { start: '7/1/1953', end: '5/1/1954' },
    // { start: '8/1/1957', end: '4/1/1958' },
    // { start: '4/1/1960', end: '2/1/1961' },
    // { start: '12/1/1969', end: '11/1/1970' },
    // { start: '11/1/1973', end: '3/1/1975' },
    // { start: '1/1/1980', end: '7/1/1980' },
    // { start: '7/1/1981', end: '11/1/1982' },
    // { start: '7/1/1990', end: '3/1/1991' },
    // { start: '3/1/2001', end: '11/1/2001' },
    { start: '12/1/2007', end: '6/6/2009' }];
  recessionData.forEach((d) => { d.start = rParser(d.start); d.end = rParser(d.end); });

  // const maxValue = max(data, d => d.amt);
  // const minValue = min(data, d => d.amt);

  const xAxisDateConfig = {
    orientation: 'bottom',
    domain: extent(data, d => parser(d.label)),
    range: [0, width],
    nice: false,
  };

  // const maxValue = max(data, d => d.amt);
  // const minValue = min(data, d => d.amt);

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width - 5],
    domain: data.map(d => d.label),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [height, 0],
    domain: [-40, 10],
    nice: false,
  };

  const { axis: xAxisTime, scale: xTime } = timeAxis(xAxisDateConfig);
  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  return {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    xTime,
    y,
    xAxis,
    yAxis,
    margins,
    recessionData,
  };
}
